import { PUBLIC_BACKEND } from '$app/env/public';
import { type BoatsResponse, type TypedPocketBase } from '@/pocketbase/pocketbase-types';
import { ClearBoatFiles } from '@/stores/uploadBoatFilesStore';
import { uploadBoatStore } from '@/stores/uploadBoatStore';
import PocketBase, { ClientResponseError } from 'pocketbase';
import { writable } from 'svelte/store';

export const pb = new PocketBase(PUBLIC_BACKEND) as TypedPocketBase;
export const currentUser = writable(pb.authStore.record);

pb.authStore.onChange((auth) => {
	console.log('authStore changed', auth);
	currentUser.set(pb.authStore.record);
});

export function clearUserStores() {
	ClearBoatFiles();
	uploadBoatStore.set({} as BoatsResponse);
}

export function getErrorMessage(error: ClientResponseError) {
	// Check if there's a detailed message in error.response.data
	if (error.response && error.response.data) {
		const data = error.response.data as Record<string, unknown>;
		if (typeof data.message === 'string' && data.message) {
			return data.message;
		}
		for (const key in data) {
			const field = data[key];
			if (
				field &&
				typeof field === 'object' &&
				'message' in field &&
				typeof (field as { message: string }).message === 'string'
			) {
				return (field as { message: string }).message;
			}
		}
	}
	// Check for a general message in error.response
	if (error.response && error.response.message) {
		return error.response.message;
	}
	// Fallback to the top level message
	return error.message || 'An unknown error occurred.';
}
